export default "__VITE_ASSET__9ee0078c__"